/*
 * Copyright (c) 2019.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {TypePrice} from './TypePrice';
import {Organization} from './Organization';
import {CounterParty} from './CounterParty';
import {Customer} from './Customer';
import {Segment} from './Segment';

export interface Contract {
  id?: number;
  header: string;
  priceType?: TypePrice;
  organization?: Organization;
  customer?: Customer;
  counterParty?: CounterParty;
  segments?: Segment[];
  limitDay?: bigint;
  limitSum?: bigint;
  reserve?: bigint;
  deleted?: boolean;
  enabled?: boolean;
  counterPartyId?: number;
  customerId?: number;
  priceTypeId?: number;
  organizationId?: number;
}
